import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import { connect } from "react-redux";
import Loader from "../../../sharedComponents/preloader";
import { resetField, getFoodApprovalList, searchPatientFood } from "../../../store/actions";
import { get } from "lodash";
import SearchPatientFood from "../foodDatabase/searchPatientFood";
import { objToQueryString } from "../../../utils/common";
import "./FoodDatabase.scss";

const FoodApproval = ({ history, foodList, resetField, getFoodApprovalList, isAdmin, searchPatientFood, next, prev }) => {
	const [food, setFood] = useState([]);
	const [fetching, setFetching] = useState(false);
	const [loading, setLoading] = useState(true);
	const [showLoader, setShowLoader] = useState(true);
	const [filters] = useState({
		declined: "True",
		limit: 30,
		offset: 30,
		ordering: "id",
	});

	const [query, setQuery] = useState();

	useEffect(() => {
		const newFilters = { ...filters };
		setQuery(objToQueryString(newFilters));
	}, [filters]);

	useEffect(() => {
		if (query) {
			setFood([]);
			setLoading(true);
			setShowLoader(true);
			getFoodApprovalList(query);
		}
	}, [query, getFoodApprovalList]);

	useEffect(() => {
		setShowLoader(false);
		if (foodList !== null && foodList.length === 0) {
			setLoading(false);
		}
		setFood([...(foodList !== null ? foodList : [])]);
	}, [foodList]);

	useEffect(() => {
		fetching && getFoodApprovalList(next.split("?")[1]);
		fetching && setShowLoader(true);
		setFetching(false);
	}, [fetching, getFoodApprovalList, next]);

	useEffect(() => {
		return () => {
			resetField("FoodDatabase.foodApprovalList", {});
		};
	}, [resetField]);

	const dropdownClick = (path) => {
		history.push(path);
	};

	const goToPage = (event) => {
		history.push(`/nutrition/food-database/approval/${event.id}/details`);
	};

	const columns = [
		{
			Header: "Food",
			accessor: "long_desc",
			sortable: true,
			width: 800,
			Cell: ({ original }) => (
				<span href="#" className="text-primary-dark pointer" onClick={() => goToPage(original)}>
					{original.name ? original.name : ""}
				</span>
			),
		},
		{
			Header: "Actions",
			accessor: "useful",
			sortable: false,
			width: 100,
			Cell: ({ original }) => (
				<button className="btn btn-primary-dark mr-2 btn-sm" onClick={() => goToPage(original)}>
					{" "}
					<i className="icon icon-eye"></i>View{" "}
				</button>
			),
		},
	];

	return (
		<section className="page page-food-database">
			<div className="container">
				<h3>Patient Food Submissions</h3>
				<div className="row card-wrap">
					<div className="col-9 ">
					{loading ? <Loader show={showLoader} /> : null}

						{foodList && foodList.length ? (
							<div className="card card-primary p-4 m-0 w-100">
								<PaginatedTable
									data={food}
									columns={columns}
									next={next}
									prev={prev}
									onPagination={(event) => searchPatientFood(`${event}`)}
								/>
							</div>
						) : null}


					</div>

					<div className="col-3 ">
						<div className="card card-primary p-4 m-0 mb-5 w-100">
							<Dropdown drop="down" className="approve-btn mr-2">
								<Dropdown.Toggle className="btn btn-primary-dark btn-ghost mr-2">
									Patient Submissions
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<ul className="menu-list">
										<li onClick={() => dropdownClick("/nutrition/food-database")}>Food Listing</li>
									</ul>
								</Dropdown.Menu>
							</Dropdown>
						</div>

						<div className="card card-primary p-4 m-0 w-100">
							<h4 className="search-head text-primary-dark">Search Food Nutrition</h4>
							<SearchPatientFood />
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { FoodDatabase, UI, Auth } = state;
	return {
		foodList: get(state, "FoodDatabase.foodApprovalList.results", []),
		next: get(FoodDatabase, "foodApprovalList.next"),
		prev: get(FoodDatabase, "foodApprovalList.previous"),
		atBottom: UI.atBottom,
		isAdmin: get(Auth, "isAdmin", "P"),
	};
};

const mapDispatchToProps = {
	getFoodApprovalList,
	searchPatientFood,
	resetField,
};

export default connect(mapStateToProps, mapDispatchToProps)(FoodApproval);
